import Backbone from 'backbone';
import { on, off, getElement } from 'utils/mixins';
const $ = Backbone.$;

module.exports = Backbone.View.extend({
  tagName: 'div',

  template() {
    return `<div class="emoji"></div>`;
  },

  initialize(o) {
    _.bindAll(this, 'renderContent');
    const model = this.model;
    model.view = this;
    this.conf = o.config || {};
    this.pfx = this.conf.stylePrefix || '';
  },

  renderContent() {
    const { $el, model, conf } = this;
    const that = this;
    $el.html(this.template());

    conf.emoji_smileys.forEach(element => {
      $el
        .find('.emoji')
        .append(
          `<span class="intercom-emoji-picker-emoji" title="${element}">&#${element}</span>`
        );
    });

    $el.find('.intercom-emoji-picker-emoji').on('click', function(e) {
      model.trigger('emojiClick', $(this).html());
    });
  },

  render() {
    const { $el, model } = this;
    $el.attr({ class: `${this.pfx}myEmoji`, id: 'myEmoji' });
    this.renderContent();
    return this;
  }
});
